/**
 * @generated SignedSource<<15e13d822f833cf8f127bb54da20d419>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useGetMappingFieldsQuery$variables = {
  organizationId: number;
};
export type useGetMappingFieldsQuery$data = {
  readonly sys_mapping_fields: ReadonlyArray<{
    readonly mapping_field_description: string;
    readonly mapping_field_name: string;
  }>;
};
export type useGetMappingFieldsQuery = {
  response: useGetMappingFieldsQuery$data;
  variables: useGetMappingFieldsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "is_active",
            "value": {
              "_eq": true
            }
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "organizationId"
              }
            ],
            "kind": "ObjectValue",
            "name": "organization_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_mapping_fields",
    "kind": "LinkedField",
    "name": "sys_mapping_fields",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mapping_field_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mapping_field_description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGetMappingFieldsQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetMappingFieldsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4316ce3abe3e07b5333850b4845ada15",
    "id": null,
    "metadata": {},
    "name": "useGetMappingFieldsQuery",
    "operationKind": "query",
    "text": "query useGetMappingFieldsQuery(\n  $organizationId: Int!\n) {\n  sys_mapping_fields(where: {organization_id: {_eq: $organizationId}, is_active: {_eq: true}}) {\n    mapping_field_name\n    mapping_field_description\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7c378581371a01d90eca22e6299ee77";

export default node;
